import { render, staticRenderFns } from "./myStudentProduction.vue?vue&type=template&id=26b2f028&scoped=true&"
import script from "./myStudentProduction.vue?vue&type=script&lang=js&"
export * from "./myStudentProduction.vue?vue&type=script&lang=js&"
import style0 from "./myStudentProduction.vue?vue&type=style&index=0&id=26b2f028&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b2f028",
  null
  
)

export default component.exports